import { observer } from 'mobx-react-lite';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { useAppRouterPresenter } from './AppRouter.presenter';
import { BASE_ROUTE } from './AppRouter.routes';

export const AppRouter = observer(() => {
  useAppRouterPresenter();

  const router = createBrowserRouter([BASE_ROUTE], {
    basename: '/',
  });

  return <RouterProvider router={router} />;
});
